import { OrganisationsSeoIndexabilityPolicy } from '../../../organisations/policies/OrganisationsSeoIndexabilityPolicy';
import { SearchVolumeAreasDisciplineRule } from '../../../organisations/rules/SearchVolumeAreasDisciplineRule';
import { AtLeastTwoRankedResultsRule } from '../../../organisations/rules/AtLeastTwoRankedResultsRule';
import { FilterCombinations } from '../../../enums/FilterCombinations';
import { FilterKey } from '@studyportals/search-filters';
import { SortingOptions } from '../../../enums/SortingOptions';
import { SingleValueSelectedForFilterRule } from '../../../common/rules/SingleValueSelectedForFilterRule';
import { OnlyFiltersSelectedRule } from '../../../common/rules/OnlyFiltersSelectedRule';
export class RankedAreaDiscipline extends OrganisationsSeoIndexabilityPolicy {
    sortingOption = SortingOptions.UNIVERSITY_META_RANKING;
    rules = [
        new SingleValueSelectedForFilterRule(FilterKey.AREA),
        new SingleValueSelectedForFilterRule(FilterKey.COUNTRY),
        new SingleValueSelectedForFilterRule(FilterKey.DISCIPLINES),
        new OnlyFiltersSelectedRule([FilterKey.AREA, FilterKey.COUNTRY, FilterKey.DISCIPLINES]),
        new SearchVolumeAreasDisciplineRule(),
        new AtLeastTwoRankedResultsRule()
    ];
    get filterCombination() {
        return FilterCombinations.AREA_DISCIPLINE;
    }
    generateUrls() {
        throw new Error('Method not implemented.');
    }
}
